import React, { useEffect, useState, useRef } from "react";
import {
  Alert as MuiAlert,
  Box,
  Grid,
  DialogActions,
  Button,
  CircularProgress,
} from "@mui/material";
import { spacing } from "@mui/system";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, FormProvider } from "react-hook-form";
import ReplayIcon from "@mui/icons-material/Replay";
import { useDispatch } from "react-redux";

import { useDialog } from "../../../../contexts/DialogContext";
import useUser from "../../../../hooks/useUser";
import CustomTextField from "../../../../components/CustomTextField";

import { showSuccessSnackbar, showErrorSnackbar } from "../../../../redux/slices/snackbar";

const Alert = styled(MuiAlert)(spacing);

const StaticIp = (props) => {
  const dispatch = useDispatch();
  const { user, isRenewSubmitting, updateStaticIpAddress } = useUser();

  const methods = useForm();
  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
  } = methods;
  const { unSetDialog, openDialog } = useDialog();

  React.useEffect(() => {
    if (Object.keys(user).length !== 0) {
      const initialValues = {
        ipAddress: user.staticIpAddress,
      };
      reset(initialValues);
    }
  }, [user]);

  const { t } = useTranslation();

  const onSubmit = async (data) => {
    try {
      const payload = {
        userName: user.userName,
        radUserId: user.radUserId,
        ipAddress: data.ipAddress || null,
      };

      await updateStaticIpAddress(payload);
      dispatch(showSuccessSnackbar("Static Ip Address Added successfully!"));
      unSetDialog("static_ip");
    } catch (ex) {
      dispatch(showErrorSnackbar(ex.message));
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} className="row" pt={8}>
            <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
              <CustomTextField
                label={t("static_ip")}
                name="ipAddress"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<ReplayIcon />}
              endIcon={isRenewSubmitting ? <CircularProgress size={24} /> : null}
              disabled={false}
            >
              Save
            </Button>

            <Button variant="text" onClick={() => unSetDialog("static_ip")} color="primary">
              Close
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </React.Fragment>
  );
};
export default StaticIp;
